import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageLayoutStore from '@src/business-components/page-layout/store';
import ImageListStore from './components/image-list/store';
import routeConfigs from '@src/pages/app-router/route-configs';
import { getOmniData, AuditionVideoChannelId, AuditionImageId } from '@src/services/omni-api';
import aos from '@src/utils/aos';

import { computed, observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import { useEffect } from 'react';
import { HIDE_DATA } from '@src/constants/urls';

class AuditionAudioStore extends BaseStore {
  @observable hideData = HIDE_DATA;

  pageLayoutStore = new PageLayoutStore({
    type: '视听中心',
    breadcrumbNavItems: [
      {
        label: '官网首页',
        path: routeConfigs.MAIN.getFormatPath({ part: 'media' })
      },
      {
        label: '图像'
      }
    ],
    isHideTopMenu: true,
    isHideStrategy: () => this.hideData
  });

  bigImageSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      autoplay: false
    }
  });

  smallImageSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true
    }
  });

  imageListStore = new ImageListStore();

  imageBaseSwiperStore = new BaseSwiperStore();

  @observable imageList = [];
  //当前图片Index
  @observable currentImageIndex = 0;

  @computed
  get currentImage() {
    if (this.imageList.length === 0) {
      return '';
    }
    return this.imageList[this.currentImageIndex]?.cover || '';
  }

  @computed
  get prevImageIndex() {
    if (this.currentImageIndex > 0) {
      return this.currentImageIndex - 1;
    }
    return 0;
  }

  @computed
  get nextImageIndex() {
    if (this.currentImageIndex < this.imageList.length - 1) {
      return this.currentImageIndex + 1;
    }
    return this.imageList.length - 1;
  }

  getData = async () => {
    try {
      const res = await getOmniData(AuditionVideoChannelId, [
        {
          dataSourceId: AuditionImageId || '',
          page: 1,
          perPage: 99
        }
      ]);
      const data = res[AuditionImageId]?.result?.items || [];
      // console.log(data);
      // this.imageListStore.imageList = data;
      const images = [];
      data.forEach((item, index) => {
        images.push({
          id: index + 1,
          cover: item.wallpaper_mo?.[0]?.url || '',
          thumbImg: item.thumbs?.[0]?.url || '',
          title: item.title || ''
        });
      });
      // console.log(images);
      this.imageList = images;
    } catch (error) {
      console.log(error);
    }
  };
  use() {
    super.use();
    useMount(() => {
      aos.reInit();
      // setTimeout(() => {
      //   const imageList = [
      //     {
      //       cover: require('./images/media-picture-layer-10.png'),
      //       thumb: require('./images/media-picture-layer-10.png')
      //     },
      //     {
      //       cover: require('./images/media-picture-layer-11.png'),
      //       thumb: require('./images/media-picture-layer-11.png')
      //     },
      //     {
      //       cover: require('./images/media-picture-layer-12.png'),
      //       thumb: require('./images/media-picture-layer-12.png')
      //     }
      //   ];
      //   this.imageListStore.imageList = imageList;
      // }, 100);

      this.getData();
      this.pageLayoutStore.returnBtnStore.onReturnClick = () => {
        this.redirect(routeConfigs.MAIN.getFormatPath({ part: 'media' }));
      };
    });

    // useEffect(
    //   () => {
    //     this.smallImageSwiperStore.onChange(this.currentImageIndex);
    //     this.bigImageSwiperStore.onChange(this.currentImageIndex);
    //   },
    //   [this.currentImageIndex]
    // );

    useEffect(
      () => {
        this.currentImageIndex = this.bigImageSwiperStore.activeIndex;
        this.smallImageSwiperStore.onChange(this.currentImageIndex);
      },
      [this.bigImageSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.currentImageIndex = this.smallImageSwiperStore.activeIndex;
        this.bigImageSwiperStore.onChange(this.currentImageIndex);
      },
      [this.smallImageSwiperStore.activeIndex]
    );
  }
}

export default AuditionAudioStore;
